'use strict';

bbw.service.RedirectSvc = Class({

    $inject: ['$rootScope', '$location', '$timeout'],

    $rootScope: undefined,
    $location: undefined,
    $timeout: undefined,

    _canUseXhr: true,
    _timeout: undefined,

    construct: function($rootScope, $location, $timeout) {
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$timeout = $timeout;

        this.$rootScope.$on('$destroy', this.disableXhr.bind(this));
        window.addEventListener('beforeunload', this.disableXhr.bind(this));
    },

    disableXhr: function() {
        this._canUseXhr = false;
    },

    redirect: function(redirection, defaultUrl) {
        redirection = angular.isObject(redirection) ? redirection : {url: '' + redirection};
        if (!redirection.url) {
            redirection.url = defaultUrl;
            if (!redirection.url) {
                return;
            }
        }
        this._doRedirect(redirection.xhr ? new Uri(redirection.url) : redirection.url, redirection.timeout, redirection.xhr);
    },

    redirectTo: function(key, args, qsArgs, timeout, xhr) {
        var tpl = this.$rootScope.bbwUrls[key];
        if (!tpl) {
            console.error("URL not found for [" + key + "]");
            return;
        }
        var url = new Uri(ngtk.tools.string.parseTemplate(tpl, args || {}, '#'));
        if (angular.isObject(qsArgs)) {
            angular.forEach(qsArgs, function(value, key) {
                url.addQueryParam(key, value);
            });
        }
        this._doRedirect(url, timeout, angular.isUndefined(xhr) ? true : xhr);
    },

    cancel: function() {
        if (this._timeout) {
            this.$timeout.cancel(this._timeout);
            this._timeout = undefined;
        }
    },

    _doRedirect: function(url, timeout, xhr) {
        if (this._timeout) {
            this.cancel();
        }

        xhr = this._canUseXhr && xhr;
        if (!xhr) {
            this.$rootScope.$destroy();
        }
        timeout = timeout ? parseInt(timeout) : 0;
        this._timeout = this.$timeout(function() {
            if (xhr) {
                this.$location.path(url.path()).hash(null).search(url.query().substr(1));
            } else {
                document.body.innerHTML = '';
                window.location = '' + url;
            }
        }.bind(this), (timeout < 0 || isNaN(timeout)) ? 0 : timeout * 1000);
    }

});

